import script from "./table-block.vue?vue&type=script&setup=true&lang=ts"
export * from "./table-block.vue?vue&type=script&setup=true&lang=ts"

import "./table-block.vue?vue&type=style&index=0&id=3212021c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3212021c"]])

export default __exports__